import React, {createContext, useContext, useReducer}  from 'react'
import {bmiReducer} from '../reducer/bmiReducer'
import {TypeContext} from './TypeContext'
import { 
    bmiResultInCmAndKg, 
    bmiResultInPoundsAndFeet,
    bmiResultInStonsAndFeet,
    bmiResultInPoundsAndInches
} from '../utils'
import {GET_BMI, CLEAR_BMI, CLEAR_ALL, CM_KG, FEET_POUND, FEET_STONE, INCH_STONE} from '../types/Type'
import ContextDevTool from 'react-context-devtool';

//  const actions = {
//     weight: 'WEIGHT_CHANGED',
//     height: 'HEIGHT_CHANGED'
//   }

export const BmiContext = createContext();

const BmiContextProvider = (props) => {

    const init = {
      bmi: {weight: '', height: '', bmiResult: ''},
      
    }

    const [stateBMI, dispatch] = useReducer(bmiReducer, init)

    const {stateType: {selectedType}} = useContext(TypeContext);

    const onChange = (e) => {
        e.persist();
        let value = e.target.value;
        let name = e.target.name;

        // let trol = {bmi: {name: value}}
        dispatch({
            type: name,
            // payload: {bmi: {[e.target.name]: value}}
            // payload: {[e.target.name]: value}
            // payload: value
            payload: {
                    ...stateBMI.bmi,
                    [e.target.name]: value
                }
            })
        }
    
const clearBmi = () => {
    dispatch({
        type: CLEAR_BMI,
        // payload: {bmi: {bmiResult: ''}}
        payload: {
            ...stateBMI.bmi,
            bmiResult: ''
        }
      })
  }

  const clearAll = () => {
    dispatch({
      type: CLEAR_ALL,
    //   payload: {bmi: {weight: '', height: '', bmiResult: ''}}
        payload: {
            ...stateBMI.bmi,
            weight: '', height: '', bmiResult: ''
        }
    })
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    getBmiResult();
  }

  const getBmiResult = () => {
    // const bmiResult = resultBmiInCmAndKg()
    dispatch({
        type: GET_BMI,
        // payload: bmiResult
        payload: {
            ...stateBMI.bmi,
            bmiResult: resultBmiInCmAndKg()
        }
    })
  }

  const resultBmiInCmAndKg = () => {
    //   const weight = stateBMI.bmi.weight
    //   const height = stateBMI.bmi.height

      if(selectedType === CM_KG){
          return bmiResultInCmAndKg(stateBMI.bmi.weight, stateBMI.bmi.height).toFixed(2)
      } else if(selectedType === FEET_POUND) {
        return bmiResultInPoundsAndFeet(stateBMI.weight, stateBMI.height).toFixed(2)
      } else if(selectedType === FEET_STONE) {
        return bmiResultInStonsAndFeet(stateBMI.weight, stateBMI.height).toFixed(2)
    } else if(selectedType === INCH_STONE){
        return  bmiResultInPoundsAndInches(stateBMI.weight, stateBMI.height).toFixed(2)

} else {
    return  stateBMI.bmiResult = ''
}
      
}

    // const bmi = stateBMI.bmi
    return(
        <BmiContext.Provider 
            value={{
                stateBMI,
                    onChange, 
                    clearAll, 
                    clearBmi,
                    handleSubmit,
                }}>
        <ContextDevTool context={BmiContext} id="BmiContext" displayName="BmiContext" />
            {props.children}
        </BmiContext.Provider>
    )
}

export default BmiContextProvider;